import React from 'react';
import { IconButton, makeStyles, Theme, Tooltip } from '@material-ui/core';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IState } from '../../data/types';
import { isStudent, isTrainer } from '../../data/appRoles';
import { colors } from '../../theme/tokens';
import { localRoutes } from '../../data/constants';
import NotificationBell from './NotificationBell';
import { BarView } from '../Profile';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    // Below `md` the app's top bar is shown instead.
    [theme.breakpoints.down('sm')]: { display: 'none' },
  },
  // Round, bordered button behind the bell (as in the design)
  bell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 44,
    height: 44,
    marginRight: theme.spacing(1),
    borderRadius: '50%',
    background: colors.bgSubtle,
    border: `1px solid ${colors.border}`,
    boxShadow: `0 4px 12px ${colors.shadow}`,
    '& .MuiIconButton-root': { margin: 0 },
  },
  icon: { color: colors.textMuted },
}));

/** Notifications, attendance and profile for the page header. */
const HeaderActions = () => {
  const classes = useStyles();
  const history = useHistory();
  const user = useSelector((state: IState) => state.core.user);
  // Students mark attendance from their profile menu; staff get a shortcut.
  const showAttendance = !isStudent(user) && !isTrainer(user);
  return (
    <div className={classes.root}>
      {showAttendance && (
        <Tooltip title="Attendance">
          <IconButton
            size="small"
            className={classes.icon}
            onClick={() => history.push(localRoutes.attendance)}
          >
            <HowToRegIcon style={{ fontSize: 22 }} />
          </IconButton>
        </Tooltip>
      )}
      <span className={classes.bell}>
        <NotificationBell />
      </span>
      <BarView detailed />
    </div>
  );
};

export default HeaderActions;
